import { ReactPlayerProps } from 'react-player';
import dynamic from 'next/dynamic';
import classNames from 'classnames';

import { isOnSafariBrowser } from 'lib/helpers';
import styles from 'styles/VideoPlayer.module.scss';
import { StyledComponent } from 'types';

import { PlayIcon } from './PlayIcon';

import { CloudinaryImage, CloudinaryImageProps } from '../CloudinaryImage';

export type VideoPlayerProps = {
  fitContainer?: boolean;
  thumbnail?: CloudinaryImageProps;
  disablePlayIcon?: boolean;
} & ReactPlayerProps &
  StyledComponent;

const ReactPlayer = dynamic(() => import('react-player'), { ssr: false }); // dynamic imports for ReactPlayer to hydrate properly

const defaultVideoPlayerProps: ReactPlayerProps = {
  controls: true,
  playIcon: <PlayIcon size={60} />
};

const fitContainerProps: ReactPlayerProps = {
  width: '100%',
  height: '100%'
};

export const VideoPlayer: React.FC<VideoPlayerProps> = ({
  fitContainer,
  className,
  style,
  thumbnail,
  disablePlayIcon = false,
  ...playerProps
}) => (
  <ReactPlayer
    {...defaultVideoPlayerProps}
    {...playerProps}
    {...(fitContainer && fitContainerProps)}
    {...(thumbnail &&
      !isOnSafariBrowser() && {
        // Only include thumbnail when not on Safari browser since Safari does not play video immediately after clicking on thumbnail
        light: <CloudinaryImage {...thumbnail} />
      })}
    {...(disablePlayIcon && {
      playIcon: <></>
    })}
    className={classNames(
      'position-relative',
      className,
      fitContainer && styles['video-fit-container'],
      thumbnail && styles['video-thumbnail']
    )}
    style={style}
  />
);
